import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  Root: {
    gap: 15,
    paddingTop: 1,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center'
  },
  VideoCard: {
    width: 180,
    padding: 2,

    '& .MuiCardActions-root': {
      padding: '0'
    },

    '& .MuiCardContent-root': {
      padding: 0
    },

    '& .MuiCheckbox-root': {
      padding: 5
    }
  },
  Media: {
    width: '100%',
    height: 150,
    maxHeight: 150,
    display: 'block',
    objectFit: 'contain',
    borderRadius: 5
  },
  VideoCardSelected: {
    boxShadow: `0 0 1px 1px ${theme.palette.primary.light}`
  }
}));
